













































































































































































































































































































































































































































import axios from 'axios';
import Currency from '@/components/Currency.vue';
import Comprobante from '@/models/Comprobante';
import Entidad from '@/models/Entidad.vue';
export default {
	name: 'CuentaCorriente',
	inject: ['responsive'],
	components: {
		Currency,
	},
	data() {
		return {
			pickerBeginDateAfterH: {
				disabledDate: this.disabledDateH,
			},
			pickerBeginDateAfterD: {
				disabledDate: this.disabledDateD,
			},
			windowWidth: window.innerWidth,
			isMobile: false,
			radio: 1,
			valorSaldo: 0,
			signoSaldo: '',
			recordSelected: {} as Comprobante,
			searchDrawer: false,
			detailsDrawer: false,
			tableProductos: false,
			tableOtros: false,
			tableDataAll: [],
			descom: '',
			type: '',
			loading: true,
			refresh: true,
			imprimiendo: false,
			descargando: false,
			moneda: 1,
			searchForm: {
				movimiento: 1,
				rangofecha: '',
				fechaDesde: '',
				fechaHasta: '',
				fechaDesdeM: '',
				fechaHastaM: '',
				debito: true,
				credito: true,
				importefrom: '',
				importeto: '',
				codres: '',
				comprobantes: [],
				ctasctes: [],
			},
			start: 0,
			limit: 7,
			showBtnMore: false,
			window: '',
			searchRules: {
				fechaDesde: [{ type: 'date', required: true, message: 'Seleccione una fecha desde', trigger: 'change' }],
				fechaHasta: [{ type: 'date', required: true, message: 'Seleccione una fecha hasta', trigger: 'change' }],
				importefrom: [{ type: 'number', required: false, message: 'Ingrese Importe desde (numérico)', trigger: 'change' }],
				importeto: [{ type: 'number', required: false, message: 'Ingrese Importe hasta (numérico)', trigger: 'change' }],
			},
		};
	},
	watch: {
		moneda() {
			this.resetData();
			this.loadDataResumen();
		},
		$route(to, from) {
			this.refresh = true;
			this.loadDataResumen();
		},
		valores() {
			let contador = 0;
			this.valores.forEach(element => {
				contador = contador + element.valor;
				this.signoSaldo = element.signo;
			});
			this.valorSaldo = contador;
		},
	},

	computed: {
		entidadSelected(): Entidad {
			return this.$store.state.perfil.entidadSelected;
		},
		tituloResumen() {
			return this.$route.name;
		},
		carouselItems() {
			return Math.ceil(this.valores.length / 5);
		},
		carouselItemsMobile() {
			return Math.ceil(this.valores.length / 1);
		},
		detalleMobile() {
			return '<p>Florencia<p>';
		},
		detalle() {
			return `<p style= margin:0>${this.detalle}<br>${this.detalle1}<br>${this.detalle2}<br>${this.detalle3}</p>`;
		},
		valores() {
			return this.$store.state.resumen.valoresdectasctes;
		},
		resumenes() {
			return this.$store.state.resumen.resumenes;
		},
		tableData() {
			return this.$store.state.resumen.tableData;
		},
		tipodecomprobantes() {
			return this.$store.state.resumen.tipocomprobantes;
		},
		tipoctasctes() {
			return this.$store.state.resumen.tipoctasctes;
		},
		movimientos() {
			return this.$store.state.resumen.monedas;
		},
		activeHost() {
			return this.$store.state.perfil.activeHost;
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
	},
	methods: {
		blurIfRadioActive(evt?: Event) {
			// Si el foco está en el radio nativo, lo sacamos
			const el = document.activeElement as HTMLElement | null;
			if (el && el.classList && el.classList.contains('el-radio__original')) el.blur();
		},
		openSearch() {
			const active = document.activeElement as HTMLElement | null;
			if (active) active.blur(); // << saca el foco del radio antes de abrir
			this.searchDrawer = true;
		},
		disabledDateD(date) {
			if (this.searchForm.fechaHasta) return date > this.searchForm.fechaHasta;
			else return false;
		},
		disabledDateH(date) {
			if (this.searchForm.fechaDesde) return date < this.searchForm.fechaDesde;
			else return false;
		},
		tableRowClassName({ row, rowIndex }): string {
			let bg,
				clase = '';
			if (!this.responsive.isMobile) {
				if (rowIndex === 0) {
					bg = 'bgGray';
					this.gray = true;
				}
				if (this.tableData[rowIndex - 1] && this.tableData[rowIndex - 1].fecha !== row.fecha) bg = this.gray ? 'bgGray' : '';

				if (this.tableData[rowIndex - 1] && this.tableData[rowIndex - 1].fecha === row.fecha) clase = this.gray ? 'bgGray' : '';
				else if (this.tableData[rowIndex + 1] && this.tableData[rowIndex + 1].fecha === row.fecha) clase = `sacarBorde ${bg}`;
				else clase = `bordeArriba ${bg}`;

				return `${clase} style-${row.estilo}`;
			} else return '';
		},
		clickValor(tipocc): void {
			this.searchForm.ctasctes = [];
			if (tipocc) this.searchForm.ctasctes.push(tipocc);
			this.resetData();
			this.loadDataResumen();
		},
		validDates(fecha): void {
			if (!this.responsive.isMobile) {
				let date = new Date();
				date.setMonth(date.getMonth() - 12);
				let diff = fecha[1].getTime() - fecha[0].getTime();
				if (diff > 2592000000) {
					this.$message({
						message: 'La diferencia en el rango de fechas no puede ser mayor a 30 dias',
						type: 'warning',
					});
					this.searchForm.rangofecha = '';
				} else if (fecha[0] < date) {
					this.$message({
						message: 'La fecha desde debe estar dentro del último año',
						type: 'warning',
					});
					this.searchForm.rangofecha = '';
				}
			}
		},
		range(array, min: number, max: number): string {
			return array.slice(min, max);
		},
		changeMoneda(tab): void {
			if (this.$refs['searchForm']) this.$refs['searchForm'].resetFields();
			//this.$store.commit('setMoneda', this.movimientos[parseInt(tab.index)].moneda);
			this.moneda = this.movimientos[parseInt(tab.index)].moneda;
			this.resetData();
			//this.callResumen();
		},
		// Muestro el drawer con los detalles del movimiento
		showDetails(record: Comprobante): void {
			const active = document.activeElement as HTMLElement | null;
			if (active) active.blur();
			this.detailsDrawer = true;
			this.recordSelected = record;
			this.tableOtros = this.recordSelected.renglonesOtros && this.recordSelected.renglonesOtros.length !== 0;
		},
		// Busqueda que se realiza en el drawer
		doSearch(): void {
			this.searchDrawer = false;
			if (!this.responsive.isMobile) {
				this.searchForm.fechaDesde = this.searchForm.rangofecha[0] ? this.convertDate(this.searchForm.rangofecha[0]) : ' ';
				this.searchForm.fechaHasta = this.searchForm.rangofecha[1] ? this.convertDate(this.searchForm.rangofecha[1]) : ' ';
			} else {
				this.searchForm.fechaDesdeM = this.searchForm.fechaDesde ? this.convertDate(this.searchForm.fechaDesde) : ' ';
				this.searchForm.fechaHastaM = this.searchForm.fechaHasta ? this.convertDate(this.searchForm.fechaHasta) : ' ';
			}
			this.resetData();
			this.loadDataResumen();
		},
		convertDate(inputFormat: string) {
			if (!inputFormat) return;
			function pad(s: number) {
				return s < 10 ? '0' + s : s;
			}
			const d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		},
		loadDataResumen(): void {
			if (this.refresh) this.resetData();
			this.callResumen();
		},
		loadConfig(): object {
			let config: object = {
				params: {
					moneda: this.moneda,
					tipocc: `[${this.searchForm.ctasctes}]`,
					descom: `[${this.searchForm.comprobantes}]`,
					codres: this.searchForm.codres,
					fechadesde: this.responsive.isMobile ? this.searchForm.fechaDesdeM : this.searchForm.fechaDesde,
					fechahasta: this.responsive.isMobile ? this.searchForm.fechaHastaM : this.searchForm.fechaHasta,
					importedsd: this.searchForm.importefrom,
					importehst: this.searchForm.importeto,
					credito: this.searchForm.credito,
					debito: this.searchForm.debito,
				},
			};
			this.config = config;
			return config;
		},
		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.loadDataResumen();
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.loadDataResumen();
		},
		doImprimir(type: string): void {
			let url_corta;
			switch (this.$route.path) {
				case '/1/cronologico':
					url_corta = `./api/public/proxy/cgi/etenet_rencbtec`;
					break;
				case '/1/financiero':
					url_corta = `./api/public/proxy/cgi/etenet_rencbtef`;
					break;
				case '/1/canjes':
					url_corta = `./api/public/proxy/cgi/etenet_rencbtej`;
					break;
			}
			let params = {
				url: url_corta,
				type: type,
				data: this.loadConfig(),
				cooperativa: this.$store.state.config.cuit,
			};
			// console.log(`${params.url}?fechadesde=${params.data.params.fechadesde}&fechahasta=${params.data.params.fechahasta}&descom=${params.data.params.descom}&codres=${params.data.params.codres}&credito=${params.data.params.credito}&debito=${params.data.params.debito}
			// 	&moneda=${params.data.params.moneda}&importedsd=${params.data.params.importedsd}&importehst=${params.data.params.importehst}&token=${this.$store.state.perfil.remotetoken}&imprime=true&type=${params.type}&cooperativa=${params.cooperativa}`);
			window.open(
				`${params.url}?fechadesde=${params.data.params.fechadesde}&fechahasta=${params.data.params.fechahasta}&descom=${params.data.params.descom}&codres=${params.data.params.codres}&credito=${params.data.params.credito}&debito=${params.data.params.debito}
				&moneda=${params.data.params.moneda}&importedsd=${params.data.params.importedsd}&importehst=${params.data.params.importehst}&token=${this.$store.state.perfil.remotetoken}&files=true&type=${params.type}&cooperativa=${params.cooperativa}&entity_id=${axios.defaults.headers.common.Entity_ID}`
			);
		},
		downloadFiles(): void {
			let config = this.loadConfig();
			config.params.zip = true;
			config.params.files = true;
			let url_corta;
			switch (this.$route.path) {
				case '/1/cronologico':
					url_corta = `./api/public/proxy/cgi/etenet_rencbtec`;
					break;
				case '/1/financiero':
					url_corta = `./api/public/proxy/cgi/etenet_rencbtef`;
					break;
				case '/1/canjes':
					url_corta = `./api/public/proxy/cgi/etenet_rencbtej`;
					break;
			}
			let params = {
				url: url_corta,
				data: config,
			};
			this.descargando = true;
			this.$store.dispatch('downloadFiles', params).then(response => {
				if (response.success) {
					console.log('activeHOST', this.activeHost + '/' + response.url);
					window.open(this.activeHost + '/' + response.url);
					let params = {
						url: response.url,
						directorio: response.directorio,
					};
					this.$store.dispatch('dropFiles', params).then(result => {
						this.descargando = false;
					});
				} else {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar los archivos',
						position: 'top-right',
					});
				}
				this.descargando = false;
			});
		},
		downloadFile(): void {
			let url = `./api/public/proxy/files?codcom=${this.recordSelected.codcom}&codtal=${this.recordSelected.codtal}&numero=${this.recordSelected.numero}&cooperativa=${this.$store.state.config.cuit}&type=pdf`;
			window.open(url);
			this.imprimiendo = false;
		},
		resetData(): void {
			this.$store.commit('setTableData', []);
			this.start = 0;
			this.limit = 7;
		},
		callResumen(): void {
			this.loading = true;
			this.refresh = true;
			let params = {
				path: this.$route.path,
				start: this.start,
				limit: this.limit,
				data: this.loadConfig(),
			};
			this.$store.dispatch('callResumen', params).then((response: Comprobante[]) => {
				response.length < 7 ? (this.showBtnMore = false) : (this.showBtnMore = true);
				this.loading = false;
				this.refresh = false;
				const conta = document.querySelector('.el-main');
				if (conta) conta.scrollTop = this.scrollPosition;
			});
		},
		numberFormatter(row: { letra: string; torig: string; norig: string }): string {
			return `${row.letra}  ${row.torig}  ${row.norig}`;
		},
		changeResumen(resumen) {
			this.$nextTick(() => {
				const el = document.activeElement as HTMLElement | null;
				if (el && el.classList.contains('el-radio__original')) el.blur();
			});
			this.searchForm.codres = resumen;
			this.loading = true;
			this.resetData();
			this.loadDataResumen();
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
	},
	mounted() {
		this.loading = true;
		let d = new Date();
		d.setMonth(d.getMonth() - 6);
		d.setDate(d.getDate() - (d.getDate() - 1));
		if (!this.responsive.isMobile) this.searchForm.fechaDesde = this.convertDate(d);
		this.resetData();
		this.loadDataResumen();
		if (!this.responsive.mobile) window.addEventListener('scroll', this.updateScroll);
		this.window = window;
	},
	destroyed() {
		if (!this.responsive.mobile) window.removeEventListener('scroll', this.updateScroll);
	},
};
